import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import React, { useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";

import OrdersListViewWithoutNav from "@screens/OrdersList/View/OrdersListViewWithoutNav";
import OrdersListView from "@screens/OrdersList/View";
import { getAllOrders } from "@services/api";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import t from "@constants/localization";
import { normalize } from "@constants/metrics";
import { colors } from "@constants/theme";
import ChevronRight from "@assets/svg/ChevronRight";
import analytics from "@services/analytics";
import { VACATION_EVENTS } from "@constants/analyticsEventsCT";

const PATH = "screens/Vacation/VacationOrdersList";

const VacationOrdersList = (props) => {
  const [orders, setOrders] = useState([]);
  const [isFetchingOrders, setIsFetchingOrders] = useState(true);
  const [canFetchOrders, setCanFetchOrders] = useState(true);
  const { url } = useSelector((state) => state.auth.user);
  const offset = useRef(0);
  const limit = useRef(10);
  const totalOrders = useRef(0);

  useEffect(() => {
    fetchCustomerOrders(true);
  }, []);

  const eventProps = {
    event: VACATION_EVENTS.VACATION_ORDER_CLICKED,
    Screen: "vacation",
  };

  const fetchCustomerOrders = (firstCall = false) => {
    setCanFetchOrders(orders.length >= totalOrders.current);
    if (!firstCall && orders.length >= totalOrders.current) {
      return;
    }
    if (Array.isArray(orders) && orders.length < totalOrders.current) {
      offset.current = firstCall
        ? offset.current
        : offset.current + limit.current;
    }
    const payload = {
      offset: offset.current,
      limit: limit.current,
      url,
      userId: "",
      vacationMode: true,
    };
    getAllOrders(payload)
      .then(({ data }) => {
        totalOrders.current = data.count;
        setOrders(orders.concat(data.orders));
        setIsFetchingOrders(false);
      })
      .catch((e) => {
        console.log(e);
        setIsFetchingOrders(false);
      });
  };
  return (
    <>
      <HeaderWithBackAndTitle
        headertitle={t(`${PATH}/vacationOrder`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={props.navigation}
        route={props.route}
      />
      <OrdersListView
        isProfileShow={true}
        waText={t(`${PATH}/shareBill`)}
        orders={orders}
        fetchCommunityLeaderOrders={fetchCustomerOrders}
        loading={isFetchingOrders}
        canFetchOrders={canFetchOrders}
        isVacationOrder={true}
        eventProps={eventProps}
      />
    </>
  );
};

export default VacationOrdersList;

export const HorizontalOrdersList = ({
  navigation,
  ordersList = [],
  isFetchingOrders = false,
  fetchOrders = () => {},
}) => {
  const eventProps = {
    event: VACATION_EVENTS.VACATION_ORDER_CLICKED,
    Screen: "vacation",
  };

  const onViewAllOrders = () => {
    analytics.trackEvent(VACATION_EVENTS.VIEW_ALL_ORDERS, {
      Screen: "vacation",
    });
    navigation.navigate("VacationOrdersList");
  };

  return (
    <View
      style={{
        backgroundColor: colors.lineColor,
        marginTop: 16,
      }}
    >
      <View style={styles.sectionHeader}>
        <Text style={styles.sectionText}>{t(`${PATH}/vacationOrder`)}</Text>
        <TouchableOpacity style={styles.rightButton} onPress={onViewAllOrders}>
          <Text style={styles.rightButtonText}>{t(`${PATH}/viewAll`)}</Text>
          <View style={styles.icon}>
            <ChevronRight pathFill={colors.primary} />
          </View>
        </TouchableOpacity>
      </View>
      <OrdersListViewWithoutNav
        horizontal={true}
        orders={ordersList}
        fetchCommunityLeaderOrders={fetchOrders}
        loading={isFetchingOrders}
        canFetchOrders={false}
        showUserName={false}
        showPhone={false}
        isVacationOrder={true}
        eventProps={eventProps}
        navigation={navigation}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  sectionHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 16,
  },
  sectionText: {
    fontSize: normalize(16),
    color: colors.black,
    fontFamily: "NotoSansDevanagari-SemiBold",
    lineHeight: normalize(24),
  },
  rightButton: {
    flexDirection: "row",
    alignItems: "center",
  },
  rightButtonText: {
    fontSize: normalize(14),
    color: colors.primary,
    fontFamily: "NotoSansDevanagari-Medium",
    lineHeight: normalize(20),
  },
  icon: {
    marginLeft: normalize(8),
    height: normalize(12),
    width: normalize(12),
  },
});
